export default __webpack_public_path__ + "static/media/analytics-icon.a95bfc7e.svg";